import apiService from "./api";

const itPortalService = {
  sendOtp: async () => {
    return apiService.post("/superadmin/it-portal/send-otp");
  },

  verifyOtp: async (otp) => {
    return apiService.post("/superadmin/it-portal/verify-otp", { otp });
  },

  getConfigs: async () => {
    return apiService.get("/superadmin/it-portal/configs");
  },

  updateConfigs: async (data) => {
    return apiService.put("/superadmin/it-portal/configs", data);
  },
};

export default itPortalService;
